/* eslint-disable import/no-cycle */
import { action, makeObservable, observable } from 'mobx';
import { InvoiceStatus } from '../../swagger/api';
import { FilterMenuContent, FilterObject, Filters } from '../../Types';
import BaseStore from '../base-stores/BaseStore';
import { RootStore } from '../RootStore';
import { GetInvoiceStatusesByMKInvoiceStatus, MKInvoiceStatus } from '../../utils/invoiceStatuses';

export type InvoiceTableFilter = {
  dates: FilterObject[];
  invoiceStatus: FilterObject[];
};
export default class InvoiceFilterStore extends BaseStore {
  // allMenus is initialized on CMS content load in the method setInvoiceFilterContentInit() of CMSStore.tsx
  allMenus: FilterMenuContent = {};

  activeFilters: InvoiceTableFilter = {
    dates: [],
    invoiceStatus: []
  };

  temporaryFilters: InvoiceTableFilter = {
    dates: [],
    invoiceStatus: []
  };

  invoiceSearchVal: string = '';

  fromDate: Date | null = null;

  toDate: Date | null = null;

  requestParams: {
    accountId: string;
    searchString?: string | undefined;
    fromDate?: string | undefined;
    toDate?: string | undefined;
    pageNumber?: number | undefined;
    invoiceStatusList?: InvoiceStatus[];
  } = {
    accountId: ''
  };

  setRequestParams = () => {
    this.requestParams.searchString = this.invoiceSearchVal;
    this.requestParams.pageNumber = this.rootStore.paymentStore.invoicePageNumber;
    if (this.activeFilters.invoiceStatus.length > 0) {
      const combined = this.activeFilters.invoiceStatus.flatMap((f) =>
        GetInvoiceStatusesByMKInvoiceStatus(f.filter as MKInvoiceStatus)
      );
      this.requestParams.invoiceStatusList = [...new Set(combined)];
    } else {
      this.requestParams.invoiceStatusList = undefined;
    }
    this.requestParams.fromDate = this.fromDate
      ? this.fromDate?.toLocaleString('en-US')
      : undefined;
    this.requestParams.toDate = this.toDate ? this.toDate?.toLocaleString('en-US') : undefined;
  };

  setFromDate = (fromDate: Date) => {
    this.fromDate = fromDate;
  };

  setToDate = (toDate: Date) => {
    this.toDate = toDate;
  };

  clearDateFilters = () => {
    this.fromDate = null;
    this.toDate = null;
  };

  setInvoiceSearchVal = (searchString: string) => {
    this.invoiceSearchVal = searchString;
    this.rootStore.paymentStore.setInvoicePageNumber(1);
  };

  setActiveFilters = (temporaryFilters: Filters) => {
    this.activeFilters = JSON.parse(JSON.stringify(temporaryFilters));
    this.rootStore.paymentStore.setInvoicePageNumber(1);
  };

  setTemporaryFilters = (filters: Filters) => {
    this.temporaryFilters = JSON.parse(JSON.stringify(filters));
  };

  resetInvoiceFilters = () => {
    const emptyFilter: InvoiceTableFilter = {
      dates: [],
      invoiceStatus: []
    };
    this.setActiveFilters(emptyFilter);
    this.setTemporaryFilters(emptyFilter);
    this.clearDateFilters();
    this.setInvoiceSearchVal('');
  };

  constructor(rootStore: RootStore) {
    super(rootStore);
    makeObservable(this, {
      allMenus: observable,
      activeFilters: observable,
      invoiceSearchVal: observable,
      temporaryFilters: observable,
      fromDate: observable,
      toDate: observable,
      setFromDate: action,
      setToDate: action,
      clearDateFilters: action,
      setInvoiceSearchVal: action,
      setActiveFilters: action,
      setTemporaryFilters: action
    });
  }
}
